"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class SelectionField extends EditorFieldBase_1.EditorFieldBase {
}
exports.SelectionField = SelectionField;
